import cn from './cn'
import en from './en'
import ey from './rus'


import { getLang } from "@/utils/auth"
let language  = en

if(getLang()=='ey'){
    language = ey
}else if(getLang()== 'cn'){
    language  = cn

}else {
    language  = en 
}

export const Tlang = language